import DOMPurify from 'dompurify';

/**
 * Testo formattato scritto dalla dashboard (RichTextField): solo quello che
 * offre la barra dell'editor. Va sempre sanificato prima di finire in
 * dangerouslySetInnerHTML, anche se a scriverlo è un admin.
 */
export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'h3', 'ul', 'ol', 'li', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });
}

const escapeHtml = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);

// Solo i tag che l'editor produce: "<due>" in un testo semplice resta testo.
const looksLikeHtml = (text: string) => /<\/?(p|br|strong|em|u|s|h3|ul|ol|li|a)\b[^>]*>/i.test(text);

/**
 * HTML pronto da mostrare. I testi salvati prima dell'editor formattato sono
 * semplice testo: ogni riga diventa un paragrafo, come prima.
 */
export function richTextHtml(text: string): string {
  if (looksLikeHtml(text)) return sanitizeRichText(text);
  return text
    .split('\n')
    .filter((line) => line.trim())
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('');
}

/** Vero se il testo formattato non contiene parole (es. solo "<p></p>"). */
export const isRichTextBlank = (html: string) => !html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
